import React from 'react'
import Header from './Header';
import Product from './Product';
import Footer from './Footer';
import { productInfo , companyConnections,customerInfo, paymentInfo , companyInfo} from './modal';
import './Style/Invoice.css'

function Invoice() {

  let total = productInfo.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0)
  let discount = (productInfo.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0) * productInfo.discount/100)  
  let lastPrice = total - discount

  var today = new Date();
  var date = today.getFullYear()+' - '+(today.getMonth()+1)+' - '+today.getDate();


  return <div className='invoice'>

      <Header 
        info={companyConnections} 
        customer={customerInfo} 
        product={productInfo} 
        date={date}
      />

      <Product 
        data={productInfo.info} 
        info={productInfo}
        total={total}
        discount={discount}
        lastPrice={lastPrice}
        />  

      <Footer paymentInfo={paymentInfo}/> 
      
  </div>
}

export default Invoice